// extracted by mini-css-extract-plugin
module.exports = {"content":"_2WY8_zrOiljU9dvoNaSMEq","title":"_1usb_DXctjlwcY2ZRedUyM","additional_field":"_3mhJNil9YHm2BUM9IDH7LH","field":"_2SbExEy_rLEt2ykShdN8I8"};